import { Component, OnInit, ViewChild } from '@angular/core';
import { CampusService } from '../../services/campus.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CreateCampusDialogComponent } from './create-campus-dialog/create-campus-dialog.component';
import { EditCampusDialogComponent } from './edit-campus-dialog/edit-campus-dialog.component';
import { Campus } from '../../models/campus.model';
import { DeleteCampusDialogComponent } from '../../delete-campus-dialog/delete-campus-dialog.component';
import { MatTableResponsiveModule } from '../../mat-table-responsive.module';

export interface CampusTable {
  name: string;
  emailDomain: string;
  status: string;
  street: string;
  city: string;
  state: string;
  zipcode: string;
  isMainCampus: boolean;
}

@Component({
  selector: 'app-campuses',
  standalone: true,
  imports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatTableResponsiveModule,
  ],
  templateUrl: './campuses.component.html',
  styleUrl: './campuses.component.scss',
})
export class CampusesComponent implements OnInit {
  loading: boolean = false;

  queryParams = new Map<string, any>();
  displayedColumns: string[] = [
    'name',
    'emailDomain',
    'status',
    'address',
    'isMainCampus',
    'manage',
  ];
  dataSource = new MatTableDataSource<CampusTable>([]);

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  pageSize: number = 5;
  page: number = 1;
  totalCount: number = -1;

  constructor(
    private campusService: CampusService,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.getCampuses();
  }

  getCampuses() {
    this.loading = true;
    this.route.params.subscribe((params) => {
      if (params['collegeId'] != undefined) {
        this.queryParams.set('collegeId', params['collegeId']);
      }
    });

    this.campusService
      .getAll(this.page, this.pageSize, this.queryParams)
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.dataSource.data = response.items;

          this.totalCount = response.totalCount;
        },
        error: () => {
          this.snackbar.open(
            'An error occured while retrieving campuses. Please try again.',
            '',
            { duration: 3000 }
          );
        },
      });
  }

  changePage(event: PageEvent): void {
    this.loading = true;
    this.pageSize = event.pageSize;
    this.page = event.pageIndex + 1;

    this.getCampuses();
  }

  openCreateDialog() {
    const dialogRefCreate = this.dialog.open(CreateCampusDialogComponent);

    dialogRefCreate.afterClosed().subscribe((result) => {
      if (result) {
        this.snackbar.open(result.message ?? 'An error has occured', '', {
          duration: 4000,
        });
      }
    });
  }

  editCampusDialog(campus: Campus) {
    const dialogRefEdit = this.dialog.open(EditCampusDialogComponent, {
      width: '70%',
      data: { campusToEdit: campus },
    });

    dialogRefEdit.afterClosed().subscribe((result) => {
      if (result) {
        this.snackbar.open(result.message ?? 'An error has occured', '', {
          duration: 4000,
        });
      }
      this.getCampuses();
    });
  }

  deleteCampusDialog(campus: Campus) {
    const dialogRefDelete = this.dialog.open(DeleteCampusDialogComponent, {
      data: { campusToDelete: campus },
    });
    dialogRefDelete.afterClosed().subscribe((result) => {
      if (result) {
        this.snackbar.open(result.message ?? 'An error has occured', '', {
          duration: 4000,
        });
      }
      this.getCampuses();
    });
  }
}
